// extracted by mini-css-extract-plugin
export var numpadContainer = "_oz-1";
export var phoneButton = "_oz-0";